import React from 'react';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';

interface NotificationBellProps {
  unreadCount: number;
  onClick: () => void;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ unreadCount, onClick }) => {
  return (
    <IconButton
      color="inherit"
      onClick={onClick}
      aria-label={`${unreadCount} unread notifications`}
    >
      <Badge badgeContent={unreadCount} color="error" invisible={unreadCount === 0}>
        <NotificationsIcon />
      </Badge>
    </IconButton>
  );
};

export default NotificationBell;
